export default "__VITE_ASSET__Ityvn$Sl__";